import { createModel } from '@rematch/core';

import { toast } from 'react-toastify';

// Constants
import URL from '../../constants/api-constants';

// Types
import type { RootModel } from './index';

// Http
import http from '../http/http-common';
import { generatePath } from 'react-router-dom';
import { AxiosError } from 'axios';

type INote = {
  id: string;
  name: string;
  member_id: string;
  cycle_id: string;
  member?: any;
  cycle?: any;
};

const DEFAULT_STATE: { data: INote | null } = {
  data: null,
};

export const note = createModel<RootModel>()({
  state: DEFAULT_STATE,
  reducers: {
    set(state, payload) {
      return {
        ...state,
        data: payload,
      };
    },
    resetState() {
      return DEFAULT_STATE;
    },
  },
  effects: () => {
    return {
      async createNote(payload) {
        try {
          const response = await http.post(URL.NOTES, payload);
          toast.success('Note created successfully');

          return response.data;
        } catch (error: unknown) {
          if (error instanceof AxiosError) {
            toast.error(
              error.response?.data?.message || 'An unexpected error occurred'
            );
          } else if (error instanceof Error) {
            toast.error(error.message);
          } else {
            toast.error('An unexpected error occurred');
          }
          throw error;
        }
      },

      async updateNote({ id, payload }) {
        try {
          const path = generatePath(URL.NOTE, { id });
          const response = await http.patch(path, payload);

          toast.success('Note updated successfully');

          return response.data;
        } catch (error: unknown) {
          if (error instanceof AxiosError) {
            toast.error(
              error.response?.data?.message || 'An unexpected error occurred'
            );
          } else if (error instanceof Error) {
            toast.error(error.message);
          } else {
            toast.error('An unexpected error occurred');
          }
          throw error;
        }
      },

      async deleteNote({ id, deleteAll = false }: { id: string; deleteAll?: boolean }) {
        try {
          const path = generatePath(URL.NOTE, { id });
          const response = await http.delete(path, deleteAll ? { params: { deleteAll: true } } : undefined);

          return response.data;
        } catch (error: unknown) {
          if (error instanceof AxiosError) {
            toast.error(
              error.response?.data?.message || 'An unexpected error occurred'
            );
          } else if (error instanceof Error) {
            toast.error(error.message);
          } else {
            toast.error('An unexpected error occurred');
          }
          throw error;
        }
      },

      async createNoteLink({ noteId, payload }) {
        try {
          const path = generatePath(URL.NOTE_LINKS, { id: noteId });
          const response = await http.post(path, payload);
          toast.success('Note link created successfully');

          return response.data;
        } catch (error: unknown) {
          if (error instanceof AxiosError) {
            toast.error(
              error.response?.data?.message || 'An unexpected error occurred'
            );
          } else if (error instanceof Error) {
            toast.error(error.message);
          } else {
            toast.error('An unexpected error occurred');
          }
          throw error;
        }
      },

      async deleteNoteLink({ noteId, linkId }) {
        try {
          const path = generatePath(URL.NOTE_LINK, { id: noteId, linkId });
          await http.delete(path);
        } catch (error: unknown) {
          if (error instanceof AxiosError) {
            toast.error(
              error.response?.data?.message || 'An unexpected error occurred'
            );
          } else if (error instanceof Error) {
            toast.error(error.message);
          } else {
            toast.error('An unexpected error occurred');
          }
          throw error;
        }
      },
    };
  },
});
